import { useNavigate } from "react-router";
import { useCallback } from "react";
import { useDynamicPageStepperStore } from "@companion-core/shared/app/Store/dynamicPageStepperStore";

// The web router unmounts the route on navigation, so the screen is always the active one.
export const useIsScreenFocused = () => true;

export const useRedirectToNextStep = () => {
  const navigate = useNavigate();
  const { pages, pageSlug, setStepIndex } = useDynamicPageStepperStore();
  const stepIndex = pages.onboarding.stepIndex;
  const nextStepIndex = stepIndex + 1;
  const canRedirectToNextStep = useCallback((): boolean => {
    return pageSlug === "onboarding" && nextStepIndex < pages["onboarding"].blocks.length;
  }, [stepIndex, pages.onboarding.blocks.length]);

  const redirectToNextStep = () => {
    setStepIndex(nextStepIndex);
    navigate("/onboarding");
  };
  const redirectToHome = () => {
    navigate("/home");
  };

  return canRedirectToNextStep() ? redirectToNextStep : redirectToHome;
};
